var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OperacionGenericaDto } from "./operacionGenericaDto.model";
var OperacionAlegacionDto = /** @class */ (function (_super) {
    __extends(OperacionAlegacionDto, _super);
    function OperacionAlegacionDto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.alegacion = null;
        _this.fechaAlegacion = null;
        return _this;
    }
    return OperacionAlegacionDto;
}(OperacionGenericaDto));
export { OperacionAlegacionDto };
